import { render, staticRenderFns } from "./Setphoto.vue?vue&type=template&id=f53ebc3e"
import script from "./Setphoto.vue?vue&type=script&lang=js"
export * from "./Setphoto.vue?vue&type=script&lang=js"
import style0 from "./Setphoto.vue?vue&type=style&index=0&id=f53ebc3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports